import React from 'react'
import Button from '../../components/general/button/ButtonMinimalist'
import { useNavigate } from 'react-router-dom'
import CompanyLogo from '../../assets/images/NicoLetrasAniversario.webp';
import './style.css'

export default function FinishRegister() {

    let navigateTo = useNavigate()

  return (
    <div className='Register'>
        <div className='register-page'>
            <img src={CompanyLogo}/>
            <h2>Registro Exitoso</h2>
            <p>Nuestro equipo está verificando tus datos</p>
            <p>Nos comunicaremos contigo en la brevedad</p>
            <Button text="Volver al Inicio" onClick={() => navigateTo("../../")}/>
        </div>
    </div>
  )
}
